import React from 'react';
import './PricingSection.css';

const PricingSection = () => {
  return (
    <section className="pricing-section">
      <div className="pricing-header">
        <h2>¿Por qué ser vendedor en MEGALOTO?</h2>
        <p>¡Comienza a ganar comisiones y premios con nuestro sistema de referidos y ventas!</p>
      </div>

      <div className="pricing-grid">
        <div className="pricing-card">
          <div className="pricing-icon">
            <i className="fas fa-hand-holding-usd"></i>
          </div>
          <h3>Comisiones por Recarga</h3>
          <p>Recibe el <span className="highlight">10%</span> de cada recarga realizada por tus referidos.</p>
          <p>¡Tu esfuerzo tiene recompensa, cada acción cuenta!</p>
        </div>

        <div className="pricing-card">
          <div className="pricing-icon">
            <i className="fas fa-trophy"></i>
          </div>
          <h3>Premios por Ganadores</h3>
          <p>Si uno de tus referidos gana, recibirás <span className="highlight">40%</span> de su premio.</p>
          <p>¡Potencia tu red y gana en grande!</p>
        </div>

        <div className="pricing-card">
          <div className="pricing-icon">
            <i className="fas fa-users"></i>
          </div>
          <h3>Referidos de Segundo Nivel</h3>
          <p>Si tus referidos traen más usuarios, te llevas el <span className="highlight">5%</span> de sus ventas.</p>
          <p>¡Crea una red de ventas ilimitada!</p>
        </div>

        <div className="pricing-card">
          <div className="pricing-icon">
            <i className="fas fa-star"></i>
          </div>
          <h3>Genera Más Ingresos</h3>
          <p>¡Con cada transacción y cada referido, tus ganancias crecen exponencialmente!</p>
          <p>Recibe beneficios de todos los niveles.</p>
        </div>
      </div>

      <div className="cta-section">
        <a href="https://wa.me/573133956853?text=Estoy%20interesado%20en%20unirme%20al%20grupo%20de%20ventas%20de%20Megaloto,%20me%20das%20más%20informacion,%20por%20favor" className="cta-button">¡Únete ahora y comienza a ganar!</a>
      </div>
    </section>
  );
}

export default PricingSection;
